"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationConfig = void 0;
var notificationConfig = exports.notificationConfig = {
  type: 'info',
  autoDismiss: false,
  transitionDuration: 250
};